import {
	mapActions,
	mapGetters
} from 'vuex';

import moment from 'moment';

import {
	EventBus
} from '@/support/event-bus';

import store from './store';

export default {
	...store,
	name: 'year',
	data: () => ({
		year: ''
	}),
	props: {
		name: {
			type: String,
			default: 'year'
		},
		label: {
			type: String,
			default: 'Ano'
		},
		required: {
			type: Boolean,
			default: true
		},
		group: {
			type: Boolean,
			default: true
		},
		onlyFuture: {
			type: Boolean,
			default: false
		},
		withNextYear: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		...mapGetters([
			'currentYear',
			'years'
		])
	},
	methods: {
		...mapActions([
			'putCurrentYear',
			'putYearsList',
			'pushYear'
		]),
		changed() {

			this.putCurrentYear(this.year);
			EventBus.$emit(`${ this.name }Changed`, this.year);

		},
		makeFullList(baseYear, currentYear) {

			let list = [];

			for (let year = currentYear; year >= baseYear; year--) {

				list.push({
					id: year,
					value: year.toString()
				});

			}

			return list;

		}
	},
	mounted() {

		this.year = this.currentYear;

		const list = this.makeFullList(2014, moment().get('Y'));
		const nextYear = moment().add(1, 'y').get('Y');

		if (this.withNextYear) {

			list.unshift({
				id: nextYear,
				value: nextYear.toString()
			});

			this.putYearsList(list);

		}

		if (this.onlyFuture) {

			this.putYearsList([{
				id: this.currentYear,
				value: this.currentYear.toString()
			}, {
				id: nextYear,
				value: nextYear.toString()
			}]);

		}

	}
};



// WEBPACK FOOTER //
// ./sources/components/calendar/year/index.js